import { useEffect, useState } from "react";

/** Pixel offset from viewport top (fixed header + breathing room). */
const SCROLL_OFFSET = 120;

/**
 * Tracks which legal section anchor is currently in view while scrolling.
 */
export function useLegalScrollSpy(sectionIds: string[]): string | null {
  const [activeId, setActiveId] = useState<string | null>(sectionIds[0] ?? null);

  useEffect(() => {
    if (sectionIds.length === 0) {
      setActiveId(null);
      return;
    }

    let rafId = 0;

    const resolveActive = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        let current = sectionIds[0]!;

        for (const id of sectionIds) {
          const el = document.getElementById(id);
          if (!el) continue;
          if (el.getBoundingClientRect().top <= SCROLL_OFFSET) {
            current = id;
          }
        }

        setActiveId((prev) => (prev === current ? prev : current));
      });
    };

    resolveActive();
    window.addEventListener("scroll", resolveActive, { passive: true });
    window.addEventListener("resize", resolveActive, { passive: true });

    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener("scroll", resolveActive);
      window.removeEventListener("resize", resolveActive);
    };
  }, [sectionIds]);

  return activeId;
}
